/**
 * The enablement process is defined as a professional intervention aiming to recognize, support and emphasize the patient's capacity to have control over her or his health and life
 */
export enum HealthEnablementProvider {
  /**
   * Hope Care
   * https://hope-care.pt/en/
   * Hope Care was the first Portuguese Digital Health company joining
   * services to products and state-of-the-art technological platforms,
   * allowing for the provision of Social Care and Health without
   * barriers.
   */
  PartnerP3N1 = 'partner-p3-n1',

  /**
   * Altice SmartAL
   * https://www.altice-empresas.pt/solucoes/iot/saude-bem-estar/smartal
   * This solution allows you to follow, in real time, your chronic or
   * senior patients, convalescence patients or post-hospital follow-up,
   * as it enables the telemonitoring of vital signs, the videoconsult
   * and the support for health-related activities, the well-being and
   * security.
   */
  PartnerP3N2 = 'partner-p3-n2',
}
